import $axios from '@/core/api-config'

class SearchService {
  search ({ query, limit = 10 }) {
    return $axios.get(`/api/search?query=${query}&limit=${limit}`)
  }
}

export const searchService = new SearchService()
